import {rolesPermission} from '@/api-services'
import {paginationHandler, parseLinkHeader} from '@/utils/common'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useRolesPermissionStore = defineStore('rolesPermissionStore', {
  state: () => ({
    allRolesPermission: [],
    rolesPermissionDetail: {},
    loading: false,
    error: null,
    rolesPermissionList: [],
    rolesPermissionListLink: {},
    rolesPermissionListLoading: false,
  }),
  getters: {
    getAllRolesPermissionWithSerialNumber() {
      return this.allRolesPermission.map((val, index) => ({
        ...val,
        serialNumber: index + 1,
      }))
    },
  },
  actions: {
    async getAllRolesPermission() {
        this.loading = true
        try {
        const response = await rolesPermission.getRolePermissions()
        const data = response.data
        this.rolesPermissionList = data
        this.allRolesPermission = data
        this.rolesPermissionListLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getRolePermissionById(id) {
        this.loading = true
        try {
        const response = await rolesPermission.getRolePermissionById(id)
        const data = response.data
        this.rolesPermissionDetail = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async postRolePermissions(payload) {
        this.loading = true
        try {
        const response = await rolesPermission.postRolePermissions(payload)
        const data = response.data
        this.rolesPermissionDetail = data
        toast.success(successHandler('CREATE_ROLES_PERMISSION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteRolePermission(id) {
        this.loading = true
        try {
        await rolesPermission.deleteRolePermission(id)
        toast.success(successHandler('DELETE_ROLES_PERMISSION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getTablePagination(page, type=null) {
      if (type) {
        this[`${type}Loading`] = true
      } else {
        this.loading = true
      }
      let response = []
      try {
        if (page === 'next') {
          response = await paginationHandler(this[`${type}Link`].next)
        } else if (page === 'prev') {
          response = await paginationHandler(this[`${type}Link`].prev)
        }
        this[type] = response.data
        if (type) {
          this[`${type}Link`] = parseLinkHeader(response.headers.link)
        } else {
          this.link = parseLinkHeader(response.headers.link)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        if (type) {
          this[`${type}Loading`] = false
        } else {
          this.loading = false
        }
      }
    },
  },
})
